<div class="place-holder">
    <app-qt-wasm></app-qt-wasm>
</div>
